const facebook = 'https://drive.google.com/uc?id=1JaxSUCbNMWcChzgi5U83hRKq7VRZOs9k';
const youtube = 'https://drive.google.com/uc?id=1H34XGjfHKd_hPgDW1Xw2MAy1s58EiA_l';
const instagram = 'https://drive.google.com/uc?id=165QpP1uZ5HvFBKBiXrx6qSwZnPCnmkoM';
const inTouch = 'https://drive.google.com/uc?id=1YuYtSMz01IkPxCrGxe093dSXKIA2A2Yl';

export {
    facebook, instagram, youtube,
    inTouch
};